module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan2-2-a892203af88c0fd00b5602e73fd7ed45.webp";